var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 12.5L8.00016 10M10.5002 12.5C11.6642 12.0573 12.7809 11.499 13.8335 10.8334M10.5002 12.5V16.6667C10.5002 16.6667 13.0252 16.2084 13.8335 15C14.7335 13.65 13.8335 10.8334 13.8335 10.8334M8.00016 10C8.44362 8.84957 9.002 7.74676 9.66683 6.70838C10.6378 5.15587 11.9898 3.87758 13.5943 2.99512C15.1988 2.11266 17.0024 1.65535 18.8335 1.66671C18.8335 3.93338 18.1835 7.91671 13.8335 10.8334M8.00016 10H3.8335C3.8335 10 4.29183 7.47504 5.50016 6.66671C6.85016 5.76671 9.66683 6.66671 9.66683 6.66671M4.25016 13.75C3.00016 14.8 2.5835 17.9167 2.5835 17.9167C2.5835 17.9167 5.70016 17.5 6.75016 16.25C7.34183 15.55 7.3335 14.475 6.67516 13.825C6.35125 13.5159 5.92457 13.3372 5.47702 13.3234C5.02946 13.3096 4.59256 13.4615 4.25016 13.75Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.09ee8758c094c803c6dcd3a50263fffe.svg";
export { ForwardRef as ReactComponent };